module.exports = __webpack_public_path__ + "static/media/marker-red.fa74fd86.png";